'use client';

import { usePathname } from 'next/navigation';
import { AuthGuard } from '@/components/auth/auth-guard';
import { Sidebar } from '@/components/layout/sidebar';
import { Header } from '@/components/layout/header';

/**
 * AppShell – Umschalter zwischen Login-Layout und Dashboard-Layout.
 *
 * Login-Seite: Kein Sidebar, kein Header, kein Auth-Guard.
 * Alle anderen Seiten: Vollständiges Dashboard-Layout mit Auth-Schutz.
 */
export function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // Login-Seite ohne Dashboard-Shell rendern
  if (pathname === '/login') {
    return <>{children}</>;
  }

  // Dashboard-Shell mit Auth-Guard
  return (
    <AuthGuard>
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex flex-1 flex-col overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto p-6">{children}</main>
        </div>
      </div>
    </AuthGuard>
  );
}
